import Input from 'component/atom/forms/input/input/Input';
import Toggle from 'component/atom/forms/toggle/Toggle';
import { useFormikContext } from 'formik';
import React from 'react';
import styles from './fields.module.scss';
import Select from 'component/atom/forms/select/select/Select';

const TextField = ({ index, field }) => {
  const formik = useFormikContext();

  const selectOptions = [
    { label: 'First Name', value: 0 },
    { label: 'Last Name', value: 1 },
    { label: 'Full Name', value: 2 },
  ];

  return (
    <div
      className={`${styles['field']} ${styles['text']} ${styles['text-container']}`}
    >
      <Input
        label='Input Label'
        placeholder='Enter Label'
        name={`formDetails[${index}].fieldLabel`}
        value={field.fieldLabel}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched?.formDetails?.[index]?.fieldLabel &&
          formik.errors?.formDetails?.[index]?.fieldLabel
        }
        touched={
          formik.touched?.formDetails?.[index]?.fieldLabel &&
          formik.errors?.formDetails?.[index]?.fieldLabel
        }
      />
      <Input
        label='Input Placeholder'
        placeholder='Enter Placeholder'
        name={`formDetails[${index}].placeHolder`}
        value={field.placeHolder}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched?.formDetails?.[index]?.placeHolder &&
          formik.errors?.formDetails?.[index]?.placeHolder
        }
        touched={
          formik.touched?.formDetails?.[index]?.placeHolder &&
          formik.errors?.formDetails?.[index]?.placeHolder
        }
      />
      <Select
        label='Field Tag'
        options={selectOptions}
        name={`formDetails[${index}].textTag`}
        value={
          typeof field?.textTag === 'number'
            ? field.textTag
            : Number(field?.textTag ?? 0)
        }
        placeholder='Select'
        onChange={(e) => {
          const v = e?.target?.value;
          const asNumber = typeof v === 'number' ? v : Number(v);
          formik.setFieldValue(
            `formDetails[${index}].textTag`,
            Number.isNaN(asNumber) ? 0 : asNumber
          );
        }}
        error={formik?.errors?.formDetails?.[index]?.textTag}
        touched={formik?.touched?.formDetails?.[index]?.textTag}
      />

      <div className={styles['fieldContainer']}>
        <Input
          label='Max Character'
          placeholder='Enter '
          name={`formDetails[${index}].characterLimit`}
          value={field.characterLimit}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched?.formDetails?.[index]?.characterLimit &&
            formik.errors?.formDetails?.[index]?.characterLimit
          }
          touched={
            formik.touched?.formDetails?.[index]?.characterLimit &&
            formik.errors?.formDetails?.[index]?.characterLimit
          }
        />
        <Toggle
          label='Required'
          left={true}
          name={`formDetails[${index}].isMandatory`}
          value={field.isMandatory}
          onChange={(e) =>
            formik.setFieldValue(
              `formDetails[${index}].isMandatory`,
              e.target.checked
            )
          }
          style={{ flexDirection: 'column' }}
        />
      </div>
    </div>
  );
};

export default TextField;
